<template>
  <div>
    <!-- <vue-html2pdf
      :show-layout="false"
      :float-layout="true"
      :enable-download="true"
      :preview-modal="false"
      filename="revenue-reports"
      :pdf-quality="2"
      :manual-pagination="true"
      pdf-format="a4"
      :pdf-margin="10"
      @progress="onProgress($event)"
      ref="html2Pdf"
    >
      <section slot="pdf-content">
        <revenue-pdf-content :contents="datas" />
      </section>
    </vue-html2pdf> -->

    <v-row>
      <v-col cols="12">
        <reports-filters @filter="filterBy" :loading="loading" />
      </v-col>
      <v-col cols="12">
        <v-row>
          <v-col
            cols="12"
            lg="auto"
            class="text-start"
            style="display: flex; align-items: center"
          >
            <span class="textLight--text font-weight-medium text-h5">
              {{ $t("reports.revenueReport") }}
            </span>
          </v-col>
          <v-spacer></v-spacer>
          <v-col cols="12" lg="auto">
            <reports-sub-filters
              @exportToExcel="exportToXL"
              @filter="filterBy"
              :exportBtnLoading="exporting"
              :disable="disableSubFilters"
            />
          </v-col>
        </v-row>
      </v-col>

      <v-col cols="12" v-if="$vuetify.breakpoint.mdAndUp">
        <v-card elevation="0" class="rounded-lg primary--text">
          <v-row align="center">
            <v-col cols="2">
              <div class="text-start ps-3">
                {{ $t("reports.course.courseName") }}
              </div>
            </v-col>
            <v-col cols="2">
              <div class="text-start">
                {{ $t("user.registration.organization") }}
              </div>
            </v-col>
            <v-col cols="2">
              <div class="text-center">
                {{ $t("reports.revenues.totalRegistrations") }}
              </div>
            </v-col>
            <v-col cols="2">
              <div class="text-center">
                {{ $t("reports.revenues.invoiceReference") }}
              </div>
            </v-col>
            <v-col cols="2">
              <div class="text-center">
                {{ $t("reports.revenues.status") }}
              </div>
            </v-col>
            <v-col cols="2">
              <div class="text-center">
                {{ $t("user.registration.invoiceAmount") }}
              </div>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
      <v-col cols="12">
        <v-row v-if="!loading && datas.length">
          <v-col cols="12" v-for="(data, index) in datas" :key="index">
            <revenue-report-card :revenueData="data" />
          </v-col>
        </v-row>
        <v-row
          v-else-if="!loading && !datas.length"
          class="textLight--text font-weight-medium"
          align="center"
        >
          <v-col cols="12">
            {{ $t("noItems") }}
          </v-col>
        </v-row>
        <v-row v-else-if="loading && !datas.length">
          <v-col cols="12"
            ><v-progress-circular
              indeterminate
              color="primary"
            ></v-progress-circular
          ></v-col>
        </v-row>
      </v-col>
      <v-col cols="12" v-if="datas && datas.length">
        <Pagination :length="totalPages" @onPageSelect="onPagination" />
      </v-col>
    </v-row>
  </div>
</template>
<script>
import RevenuePdfContent from "./pdfContent/RevenueReportsPdfContent.vue";
import RevenueReportCard from "./RevenueReportCard.vue";
import ReportsFilters from "./ReportsFilters.vue";
import ReportsSubFilters from "./ReportsSubFilters.vue";
import Pagination from "../../core-module/components/Pagination.vue";
import { excelExport } from "../methods/excelExport";
import VueHtml2pdf from "vue-html2pdf";
export default {
  data() {
    return {
      loading: true,
      datas: [],
      variables: {
        limit: 10,
        skip: 0,
      },
      exporting: false,
      totalCount: null,
      organization: null,
      training: null,
      employee: null,
      datesRange: {
        startDate: null,
        endDate: null,
      },
      search: null,
      disableSubFilters: true,
      debounceSearch: null,
      totalPages: 0,
    };
  },
  components: {
    RevenueReportCard,
    ReportsFilters,
    ReportsSubFilters,
    Pagination,
    // VueHtml2pdf,
    // RevenuePdfContent,
  },
  apollo: {
    getRevenueReports() {
      return {
        query: require("../api/query/getRevenueReports.gql"),
        variables: this.variablesDefaultValue(),
        result({ data, loading }) {
          if (
            data &&
            data.getRevenueReports &&
            data.getRevenueReports.revenueReports
          ) {
            this.datas = data.getRevenueReports.revenueReports;
            this.totalCount = data.getRevenueReports.totalCount;
            let pagesVal = this.totalCount / this.variablesDefaultValue().limit;
            this.totalPages = this.checkNumberIsFloat(pagesVal)
              ? Math.ceil(pagesVal)
              : pagesVal;
            if (this.datas.length) this.disableSubFilters = false;
            else this.disableSubFilters = true;
          }
          this.loading = loading;
        },
      };
    },
  },
  methods: {
    checkNumberIsFloat(value) {
      return Number(value) === value && value % 1 !== 0;
    },
    onPagination(val) {
      if (val > 0) {
        this.variables.skip = this.variables.limit * (val - 1);
        this.refetch();
      }
    },
    onProgress(event) {
      if (event === 100) {
        this.exporting = false;
      }
    },
    variablesDefaultValue() {
      return {
        limit: 10,
        skip: 0,
      };
    },
    exportToPdf() {
      this.exporting = true;
      this.$refs.html2Pdf.generatePdf();
    },
    filterBy(key, value) {
      if (key === "organization") {
        this.organization = value;
        this.variables = this.variablesDefaultValue();
        this.refetch();
      }
      if (key === "search") {
        clearTimeout(this.debounceSearch);
        this.debounceSearch = setTimeout(() => {
          this.apiSearch(value);
        }, 500);
      }
      if (key === "training") {
        this.training = value;
        this.variables = this.variablesDefaultValue();
        this.refetch();
      }
      if (key === "employee") {
        this.employee = value;
        this.variables = this.variablesDefaultValue();
        this.refetch();
      }
      if (key === "dates") {
        this.datesRange.startDate = value.startDate;
        this.datesRange.endDate = value.endDate;
        this.variables = this.variablesDefaultValue();
        this.refetch();
      }
    },
    apiSearch(val) {
      const searchText = val?.trim() ?? "";

      if (searchText.length > 0) {
        this.search = searchText;
        this.variables = this.variablesDefaultValue();
        this.refetch();
      } else if (searchText.length === 0 && this.search != null) {
        this.search = null;
        this.variables = this.variablesDefaultValue();
        this.refetch();
      }
    },

    async exportToXL() {
      this.exporting = true;
      let exportArr = await this.$apollo
        .query({
          query: require("../api/query/getRevenueReports.gql"),
          variables: {
            limit: 0,//1000,//export limit
            skip: 0,
            filterInput: {
              search: this.search ? this.search : null,
              training: this.training ? this.training : null,
              organization: this.organization ? this.organization : null,
              employee: this.employee ? this.employee : null,
              dateFrom: this.datesRange.startDate
                ? this.datesRange.startDate
                : null,
              dateTo: this.datesRange.endDate ? this.datesRange.endDate : null,
            },
          },
        })
        .then(result => {
          this.exporting = false;
          if (result?.data?.getRevenueReports?.revenueReports) {
            let revenueReportsData =
              result.data.getRevenueReports.revenueReports.map(
                revenueReport => {
                  let obj = {};
                  obj[this.$t("reports.course.courseName")] = revenueReport
                    ?.training?.title.length
                    ? this.getLocalisedValue(revenueReport.training.title)
                    : " - ";
                  obj[this.$t("user.registration.organization")] = revenueReport
                    ?.organization?.name.length
                    ? this.getLocalisedValue(revenueReport.organization.name)
                    : " - ";
                  obj[this.$t("reports.revenues.totalRegistrations")] =
                    revenueReport?.totalRegistrations
                      ? revenueReport.totalRegistrations
                      : " - ";
                  obj[this.$t("reports.revenues.invoiceReference")] =
                    revenueReport?.trainingRegistrationInvoice?.invoiceReference
                      ? revenueReport.trainingRegistrationInvoice
                          .invoiceReference
                      : " - ";
                  obj[this.$t("reports.revenues.status")] = revenueReport
                    ?.trainingRegistrationInvoice?.status
                    ? revenueReport.trainingRegistrationInvoice.status
                    : " - ";
                  obj[this.$t("user.registration.invoiceAmount")] =
                    revenueReport?.trainingRegistrationInvoice?.invoiceAmount
                      ? revenueReport.trainingRegistrationInvoice.invoiceAmount
                      : " - ";

                  return obj;
                }
              );
            return revenueReportsData;
          }
        });
      let name = "revenue-reports";
      let fileName = name.concat("-", this.$moment().unix());
      excelExport(exportArr, fileName);
    },
    async refetch() {
      await this.$apollo.queries.getRevenueReports.refetch({
        limit: this.variables.limit,
        skip: this.variables.skip,
        filterInput: {
          search: this.search ? this.search : null,
          training: this.training ? this.training : null,
          organization: this.organization ? this.organization : null,
          employee: this.employee ? this.employee : null,
          dateFrom: this.datesRange.startDate
            ? this.datesRange.startDate
            : null,
          dateTo: this.datesRange.endDate ? this.datesRange.endDate : null,
          // status: this.registrationStatusFilter
          //   ? this.registrationStatusFilter
          //   : null,
        },
      });
    },
  },
};
</script>
